exports = module.exports = require("../../../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AnswerType7V{display:flex;align-items:center;justify-content:center;flex-direction:column}.AnswerType7V .block{display:flex;align-items:center;flex-direction:row;margin-bottom:20px}.AnswerType7V .block .itemBlockT7{width:200px;min-height:50px;background:#fff;border:1px solid #d8d8d8;border-radius:0;display:flex;align-items:center;justify-content:center;text-align:center;padding:3px}.AnswerType7V .block .line{width:50px;background:#d8d8d8;height:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Question/components/Questions/components/Item/components/Answers/components/AnswerType7/styles.scss
// module id = 5211
// module chunks = 0